/**
 * Get SSO configuration from environment variables with defaults
 */ export function getSSOConfig() {
    // Defensive check: handle both undefined and empty string cases
    const tenantSlug = typeof process !== 'undefined' && process.env.REACT_APP_TENANT_SLUG ? process.env.REACT_APP_TENANT_SLUG : 'default';
    const apiUrl = typeof process !== 'undefined' && process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : '/api';
    return {
        tenantSlug,
        apiUrl
    };
}
/**
 * Build OAuth login URL for a provider
 */ export function buildOAuthURL(provider, tenantSlug, apiUrl) {
    return `${apiUrl}/auth/${tenantSlug}/oauth/${provider}`;
}
/** Append prompt=select_account so Microsoft/Google show the account picker. */ export function withSelectAccountPrompt(url) {
    if (!url) return url;
    try {
        const parsed = new URL(url, 'https://specra.invalid');
        parsed.searchParams.set('prompt', 'select_account');
        if (/^https?:\/\//i.test(url)) {
            return parsed.toString();
        }
        if (url.startsWith('//')) {
            return `//${parsed.host}${parsed.pathname}${parsed.search}${parsed.hash}`;
        }
        return `${parsed.pathname}${parsed.search}${parsed.hash}`;
    } catch  {
        const join = url.includes('?') ? '&' : '?';
        return `${url}${join}prompt=select_account`;
    }
}
/**
 * Build SAML SSO URL for Google Workspace
 */ export function buildGoogleSAMLURL(tenantSlug, apiUrl) {
    return `${apiUrl}/auth/${tenantSlug}/saml/google/sso`;
}
/**
 * Build SAML SSO URL for Microsoft Azure AD
 */ export function buildMicrosoftSAMLURL(tenantSlug, apiUrl) {
    return `${apiUrl}/auth/${tenantSlug}/saml/microsoft/sso`;
}
/**
 * Initiate OAuth flow by redirecting to provider
 */ export function initiateOAuthLogin(provider) {
    const config = getSSOConfig();
    const oauthUrl = buildOAuthURL(provider, config.tenantSlug, config.apiUrl);
    window.location.href = oauthUrl;
}
/**
 * Initiate SAML flow for Google Workspace by redirecting to SAML SSO endpoint
 */ export function initiateGoogleSAMLLogin() {
    const config = getSSOConfig();
    const samlUrl = buildGoogleSAMLURL(config.tenantSlug, config.apiUrl);
    window.location.href = samlUrl;
}
/**
 * Initiate SAML flow for Microsoft Azure AD by redirecting to SAML SSO endpoint
 */ export function initiateMicrosoftSAMLLogin() {
    const config = getSSOConfig();
    const samlUrl = buildMicrosoftSAMLURL(config.tenantSlug, config.apiUrl);
    window.location.href = samlUrl;
}
